import type { PoolData } from '../api/types';

interface PoolRowProps {
  pool: PoolData;
}

const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

const formatPercentage = (value: number | string | undefined): string => {
  if (value === undefined || value === null) {
    return 'N/A';
  }
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(numValue) || numValue === 0) {
    return 'N/A';
  }
  return `${numValue.toLocaleString('en-US', { 
    minimumFractionDigits: 2, 
    maximumFractionDigits: 2 
  })}%`;
};

const formatRollingAverage = (value: number | string | undefined): string => {
  return formatPercentage(value);
};

export function PoolRow({ pool }: PoolRowProps) {
  return (
    <tr className="pool-row">
      <td className="pool-name">{pool.poolName}</td>
      <td className="pool-type">
        <span className={`pool-type-badge ${pool.poolType}`}>
          {pool.poolType}
        </span>
      </td>
      <td className="tvl">{formatCurrency(pool.tvlUsd)}</td>
      <td className="current-apr highlighted">
        {formatPercentage(pool.aprCurrent)}
      </td>
      <td className="rolling-apr">{formatRollingAverage(pool.rollingAverages['1h'])}</td>
      <td className="rolling-apr">{formatRollingAverage(pool.rollingAverages['4h'])}</td>
      <td className="rolling-apr">{formatRollingAverage(pool.rollingAverages['12h'])}</td>
      <td className="rolling-apr">{formatRollingAverage(pool.rollingAverages['24h'])}</td>
      <td className="rolling-apr">{formatRollingAverage(pool.rollingAverages['7d'])}</td>
      <td className="rolling-apr">{formatRollingAverage(pool.rollingAverages['1mo'])}</td>
      <td className="rolling-apr">{formatRollingAverage(pool.rollingAverages['6mo'])}</td>
      <td className="rolling-apr">{formatRollingAverage(pool.rollingAverages['1yr'])}</td>
    </tr>
  );
}
